
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
var redirectURL = require('../redirectURL');

 
const Slowtrucks = (props) => {
    const handleOverspeedClick = (e) => {
        e.stopPropagation();
        //console.log("Overspeed ",props.data);
        
            props.context.componentParent.onShowTransitKpi(props);
        
        
        
    };
    

    return (
        <div>
			<button onClick={handleOverspeedClick} className="custom-btn f22 label label-success" title="Slow Truck" ><i className="icofont icofont-fast-delivery"></i> &nbsp;</button>
            
        </div>
    );
};

export default Slowtrucks;
